import api from '../utils/api';

const FRESH_MAP_HEADERS = {
  'Cache-Control': 'no-cache, no-store',
  Pragma: 'no-cache',
};

/** Map GET responses are cached by the browser (backend sets max-age). Always bypass. */
function mapGetConfig(params) {
  return {
    params: { ...params, _t: Date.now() },
    headers: FRESH_MAP_HEADERS,
  };
}

/** GET /robot/map/blocks — blocks for robot; may embed floors when noBlock */
export function fetchMapBlocks(robotId, params = {}) {
  return api.get(
    '/robot/map/blocks',
    mapGetConfig({ robotId, ...params }),
  );
}

/** GET /robot/map/floors — floors for one block */
export function fetchMapFloorsByBlock(blockId, params = {}) {
  return api.get(
    '/robot/map/floors',
    mapGetConfig({ blockId, ...params }),
  );
}

/** GET /robot/map/floors/by-robot — floors when robot has no blocks */
export function fetchMapFloorsByRobot(robotId, params = {}) {
  return api.get(
    '/robot/map/floors/by-robot',
    mapGetConfig({ robotId, ...params }),
  );
}

/** GET /robot/map/rooms — rooms on a floor */
export function fetchMapRooms(floorId, params = {}) {
  return api.get(
    '/robot/map/rooms',
    mapGetConfig({ floorId, ...params }),
  );
}

/** DELETE /robot/map/room/delete */
export function deleteMapRoom(floorId, roomName) {
  return api.delete('/robot/map/room/delete', {
    params: { floorId, roomName },
  });
}

/** PUT /robot/map/block/update — rename block */
export function updateMapBlock(blockId, payload = {}) {
  return api.put('/robot/map/block/update', { blockId, ...payload });
}

/** PUT /robot/map/floor/update — rename floor (name only) */
export function updateMapFloorName(floorId, floorName) {
  return api.put('/robot/map/floor/update', { floorId, floorName });
}

/** PUT /robot/map/floor/remap — JSON body (coordinates, base64 maps, etc.) */
export function remapMapFloor(payload) {
  return api.put('/robot/map/floor/remap', payload);
}

/** PUT /robot/map/floor/remap — multipart file upload (do not set Content-Type) */
export function remapMapFloorWithFiles(formData) {
  return api.put('/robot/map/floor/remap', formData);
}

/** PUT /robot/map/room/update — rename room */
export function updateMapRoomName(roomId, roomName) {
  return api.put('/robot/map/room/update', { roomId, roomName });
}
